// Подсчёт сегментов SMS — зеркало App\Helper\SmsSegments на бэкенде.
// Нужен, чтобы владелец видел цену шаблона ДО сохранения: кириллица помещается
// в сегмент по 70 символов, и «ещё пара слов» легко превращает одно SMS в два.

const GSM_BASIC = '@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?'
	+ '¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà'

const GSM_EXTENDED = '^{}\\[~]|€'

function isGsm7(text) {
	for (const char of text) {
		if (!GSM_BASIC.includes(char) && !GSM_EXTENDED.includes(char)) return false
	}
	return true
}

function gsm7Length(text) {
	let length = 0
	for (const char of text) length += GSM_EXTENDED.includes(char) ? 2 : 1
	return length
}

// Длина в кодовых единицах UTF-16: эмодзи вне BMP занимают две (как и у оператора)
function ucs2Length(text) {
	return text.length
}

export function smsInfo(text) {
	const value = String(text || '')
	if (value === '') return { 'encoding': 'GSM-7', 'length': 0, 'segments': 1, 'perSegment': 160, 'remaining': 160 }

	const gsm = isGsm7(value)
	const length = gsm ? gsm7Length(value) : ucs2Length(value)

	let segments
	let perSegment
	if (gsm) {
		segments = length <= 160 ? 1 : Math.ceil(length / 153)
		perSegment = segments > 1 ? 153 : 160
	} else {
		segments = length <= 70 ? 1 : Math.ceil(length / 67)
		perSegment = segments > 1 ? 67 : 70
	}

	return {
		'encoding': gsm ? 'GSM-7' : 'UCS-2',
		'length': length,
		'segments': segments,
		'perSegment': perSegment,
		'remaining': Math.max(0, segments * perSegment - length),
	}
}

export function smsSegments(text) {
	return smsInfo(text).segments
}

// Символы, из-за которых латинский текст уходит кириллицей (UCS-2, 70 символов в SMS):
// типографские кавычки, узбекский апостроф ‘ ʻ, длинное тире, эмодзи. Кириллические буквы
// сюда не попадают — с ними режим 70 символов и так неизбежен.
export function nonGsmChars(text) {
	const found = []
	for (const char of String(text || '')) {
		if (GSM_BASIC.includes(char) || GSM_EXTENDED.includes(char)) continue
		if (/[Ѐ-ӿ]/.test(char)) return []
		if (!found.includes(char)) found.push(char)
	}
	return found
}

// Чистка ввода шаблона: убираем только управляющие символы и эмодзи (вне BMP — их не
// берут операторы). Буквы любых алфавитов, включая ё, ў, қ, ғ, ҳ, остаются
export function cleanSmsText(text) {
	return Array.from(String(text || '')).filter((char) => {
		const code = char.codePointAt(0)
		return char === '\n' || (code >= 32 && code <= 0xFFFF)
	}).join('')
}
